import { post } from "./http";

let basic = "/content/info";

const contentApi = {
  listInfoPageApp: (params) => {
    return post(`/app/info/listInfoPage`, params);
  }, //首页-分页查询资讯列表
  listInfoPage: (params) => {
    return post(`${basic}/listInfoPage`, params);
  }, //首页-分页查询资讯列表
  listInfoPageTwo: (params) => {
    return post(`/content/appinfo/listInfoPage `, params);
  }, //商情资讯列表
  getInformationDetail: (params) => {
    return post(`${basic}/getInformationDetail`, params);
  }, //资讯-查询资讯详情
};

export default contentApi;
